// extracted by mini-css-extract-plugin
export default {"wrapper":"sectionHeading_wrapper__3lpHM","title":"sectionHeading_title__cwxs9"};